import { useTheme } from '@mui/material';
import { SVGProps } from 'react';

export const EyeClosedIcon = ({
  stroke,
  ...props
}: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();
  const strokeColor = stroke || theme.palette.action.active;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      {...props}
    >
      <path
        stroke={strokeColor}
        strokeLinecap="round"
        strokeWidth={1.5}
        d="M12 14.5a8.704 8.704 0 0 0 8.365-6.3M12 14.5a8.704 8.704 0 0 1-8.365-6.3M12 14.5v3.3m-4.835-4.766L4.8 15.4m12.034-2.366L19.2 15.4"
      />
    </svg>
  );
};
